// ** React
import { useEffect } from 'react';

// ** Sentry
import * as Sentry from '@sentry/react';

// ** React Router DOM
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

if (process.env.REACT_APP_PROJECT_STAGE !== 'local') {
  Sentry.init({
    dsn: 'https://ef8eeeedcc1e4154be8a657e995fc02e@sentry2.m5test.ru/28',
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
